import React, { Component, PropTypes } from 'react';

class ContactBody extends Component {
  constructor() {
    super();
    this.links = null;
  }
  componentDidMount() {
    const { background } = this.props;
    this.links = this.bodyEl.getElementsByTagName('a');
    console.log(this.links.length);
    [].forEach.call(this.links, (link) => {
      link.style.color = background; //eslint-disable-line
    });
  }
  render() {
    const { body } = this.props;
    const FormattedHtml = () => ({ __html: body });

    return (
      <div
        className="field-body"
        ref={(el) => { this.bodyEl = el; }}
        dangerouslySetInnerHTML={FormattedHtml()} //eslint-disable-line
      />
    );
  }
}

ContactBody.propTypes = {
  background: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default ContactBody;



// WEBPACK FOOTER //
// ./js/containers/ContactBody.js